<template>
  <div ref="layout" class="page-form page-base">
    <h3 class="title">销售计划变更单（公司/营销单元）</h3>

    <div class="form-container">
      <errors-list :errors="errorList" />
      <div class="tools">
        <!-- 页面详情状态 -->
        <form-button v-if="mode == 'edit'" @click="$router.go(-1)">返回</form-button>
        <!-- 页面新建状态 -->
        <template v-if="$_has(['WLY004', 'WLYALL']) && !conditions.plan_order">
          <form-button type="primary" @click="changeStatus('SAVE')">保存</form-button>
          <form-button icon="form-advance" @click="changeStatus('SUBMIT')">提交</form-button>
        </template>

        <template v-if="conditions.plan_order">
          <template v-if="$_has(['WLY002', 'WLY004', 'WLYALL'])">
            <template v-if="conditions.porder_status === 'E004'">
              <form-button @click="copyOrder">复制</form-button>
            </template>
            <template v-else>
              <form-button v-if="!showEdit" @click="showEdit = true">修改</form-button>
              <form-button @click="copyOrder">复制</form-button>
            </template>
          </template>
        </template>

        <template v-if="showEdit">
          <form-button @click="showEdit = false">显示</form-button>
          <template v-if="$_has(['WLY004', 'WLYALL'])">
            <template v-if="conditions.porder_status === 'E001'">
              <form-button type="primary" @click="changeStatus('SAVE')">保存</form-button>
              <form-button icon="form-advance" @click="changeStatus('SUBMIT')">提交</form-button>
            </template>
            <template v-if="conditions.porder_status === 'E002'">
              <form-button icon="form-advance" @click="changeStatus('SUBMIT')">提交</form-button>
              <form-button @click="changeStatus('CANCEL')">取消</form-button>
            </template>
            <template v-if="conditions.porder_status === 'E004'">
              <form-button>复制</form-button>
            </template>
          </template>

          <template v-if="conditions.porder_status === 'E003' && conditions.cancel">
            <form-button @click="changeStatus('CANCEL')">取消</form-button>
          </template>
        </template>
      </div>
      <el-form
        ref="form"
        :show-message="false"
        inline
        size="mini"
        label-width="120px"
        :disabled="isEdit"
        :model="conditions"
        :rules="rules"
      >
        <common-title title="基本信息" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="计划单号">
              <el-input
                v-model="conditions.plan_order"
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item class="line-16" prop="plan_number">
              <template #label>
                销售计划编号
              </template>
              <wly-input
                v-model="conditions.plan_number"
                input-type="salePlanCom"
                @enter="handleEnter"
                @handleSuffixClick="openSelectDialog"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="公司/营销单元">
              <el-input :value="conditions.sal_center_name" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="存货分类">
              <el-input :value="conditions.wlybrand_text" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="年度">
              <el-input :value="conditions.gjahr" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="单据类型">
              <el-input value="销售计划变更单(公司/营销单元)" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="adj_reason" label="变更原因">
              <el-select
                v-model="conditions.adj_reason"
                placeholder=""
                type="select"
                clearable
              >
                <el-option
                  v-for="item in selectDataOptions['A0003']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <common-title title="状态" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="备注">
              <el-input v-model="conditions.remark" type="textarea" rows="4" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :lg="8" :md="24">
            <common-title title="现有计划量" />
            <el-row>
              <el-col>
                <el-form-item label="总计划量(吨)">
                  <el-input v-model="conditions.total_qty" disabled />
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :lg="8" :md="24">
            <common-title title="现有计划额（参考）" />
            <el-row>
              <el-col>
                <el-form-item class="line-16" label="">
                  <template #label>
                    总计划额(万元)
                  </template>
                  <el-input v-model="conditions.total_amt" disabled />
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :lg="8" :md="24">
            <common-title title="本次调整计划量" />
            <el-row>
              <el-col>
                <el-form-item prop="curnt_adjqty" class="line-16" label="调整计划量(吨)">
                  <el-input v-model="conditions.curnt_adjqty" type="text" clearable />
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :lg="8" :md="24">
            <common-title title="本次调整计划额（参考）" />
            <el-row>
              <el-col>
                <el-form-item class="line-16">
                  <template #label>
                    调整计划额(万元)
                  </template>
                  <el-input v-model="conditions.curnt_adjamt" />
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="table-container">
      <TableCommon title="状态变更记录" :custome-config="() => vxeShowCustom('xTable')">
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
        />
      </TableCommon>
    </div>

    <!-- 选择通用弹窗情况 -->
    <el-dialog
      v-dialogDrag
      title="销售计划信息（公司营销单元）选择"
      :visible.sync="showDialog"
      width="70%"
      :append-to-body="true"
    >
      <template v-if="showDialog">
        <sale-plan-select-com ref="dialogEdit" />
      </template>

      <div slot="footer">
        <el-button
          type="default"
          size="small"
          icon="el-icon-circle-close"
          @click="showDialog = false"
        >取消</el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-circle-check"
          @click="submitHandle"
        >确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
const SalePlanSelectCom = () => import('@/components/dialog/SalePlanSelectCom.vue')
import { getSalePlanCompnayByNumber, getSalePlanCompnayChangeCreate } from '@/api/sap/sale-plan'
export default {
  components: {
    SalePlanSelectCom
  },
  data() {
    const rules = {
      adj_reason: [{ required: true, message: '请选择变更原因', trigger: 'change' }],
      plan_number: [{ required: true, message: '请选择销售计划单编号', trigger: 'change' }],
      curnt_adjqty: [{ required: true, message: '请填写调整计划量', trigger: 'blur' }]
    }
    return {
      rules,
      mode: 'add',
      showEdit: false,
      showDialog: false,
      selectDataOptions: {},
      errorList: [],
      loading: false,
      conditions: {
        remark: '',
        plan_order: '',
        adj_reason: '',
        total_amt: '',
        total_qty: '',
        curnt_adjamt: '',
        curnt_adjqty: '',
        plan_number: '',
        order_type: 'ZP04',
        porder_status: 'E001'
      },
      gridOptions: {
        data: [],
        columns: [
          { field: 'operationer', title: '操作员' },
          { field: 'oper_name', title: '操作员姓名' },
          { field: 'oper_status_text', title: '操作状态' },
          { field: 'changin_date', title: '变更日期' },
          { field: 'changin_time', title: '变更时间' }
        ]
      }
    }
  },
  computed: {
    isEdit() {
      if (this.conditions.plan_order) {
        return !this.showEdit
      } else {
        return false
      }
    }
  },
  created() {
    this.getSelectDictDataOrigin('A0003')
    const params = this.$route.params
    const len = Reflect.ownKeys(params).length
    // 编辑单
    if (this.$route.query.order && !len) {
      this.mode = 'edit'
      this.getDetail()
    } else if (len) {
      Object.assign(this.conditions, params)
    }
  },
  methods: {
    async getDetail() {
      const { data } = await getSalePlanCompnayByNumber({ plan_order: this.$route.query.order })
      Object.assign(this.conditions, data.ls_head || {})
      this.conditions.cancel = data.cancel
      this.gridOptions.data = data.lt_chg_history || []
    },
    copyOrder() {
      const resetFields = [
        'plan_order',
        // 'plan_number',
        'futur_adjqty',
        'futur_adjamt',
        'change_name',
        'uzeit',
        'timestamp',
        'mdate',
        'mtime',
        'mname',
        'mtimestamp',
        'porder_status'
      ]
      if (this.mode === 'add') {
        resetFields.forEach(key => {
          if (key === 'porder_status') {
            this.conditions[key] = 'E001'
          } else {
            this.conditions[key] = ''
          }
        })
        this.gridOptions.data = []
        this.showEdit = false
      } else {
        const params = { ...this.conditions }
        resetFields.forEach(key => {
          if (key === 'porder_status') {
            params[key] = 'E001'
          } else {
            params[key] = ''
          }
        })
        this.$router.replace({
          name: '10.06 销售计划变更单(公司/营销单元)',
          params
        })
      }
    },
    // 保存 提交 取消
    async changeStatus(mode) {
      this.$refs['form'].validate(async(valid, err) => {
        if (valid) {
          const params = {
            iv_mode: mode,
            user_bp: this.$store.getters.role.USER_BP,
            data: this.conditions,
            history: this.gridOptions.data
          }
          this.errorList = []
          const res = await getSalePlanCompnayChangeCreate(params)
          if (res.msg_type !== 'S') {
            this.errorList.push(res.message)
            return
          }
          this.$message.success(res.message)
          this.showEdit = false
          Object.assign(this.conditions, res.info)
          this.conditions.cancel = res.cancel
          this.gridOptions.data = res.history
        } else {
          this.errorList = this.$utilsCommon.filterErrorMsg(err)
          return false
        }
      })
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    },
    // 控件回车
    async handleEnter(e, type, data) {
      if (typeof type === 'object') {
        this.errorList ? (this.errorList = [type.message]) : this.$message.error(type.message)
        return
      }
      if (!data) return

      Object.assign(this.conditions, data.data.head)
      this.conditions.porder_status = 'E001'
      this.conditions.order_type = 'ZP04'
    },
    // 打开窗口
    openSelectDialog(e) {
      e.target.blur()
      this.showDialog = true
    },
    // 弹窗内的方法这边来处理，方便数据回调在本页面处理
    submitHandle() {
      this.$refs.dialogEdit.submitForm().then(res => {
        if (res) {
          Object.assign(this.conditions, res)
          // const { plan_number, total_qty, total_amt } = res
          // this.conditions.total_qty = total_qty
          // this.conditions.total_amt = total_amt
          // this.conditions.plan_number = plan_number
        }
        this.showDialog = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.layout {
  padding: 0 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/sale-plan-manage/salePlanChangeCompany.vue